var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { get } from "lodash";
var getLowestAndHighestMetrics = function (teams, metric) {
    var lowest = Infinity;
    var highest = 0;
    if (teams && teams.length > 0) {
        teams.forEach(function (team) {
            var field = get(team, metric);
            if (field < lowest) {
                lowest = field;
            }
            if (field > highest) {
                highest = field;
            }
        });
        return teams.map(function (team) {
            var field = get(team, metric);
            if (field === lowest)
                return __assign(__assign({}, team), { lowest: true });
            if (field === highest)
                return __assign(__assign({}, team), { highest: true });
            return team;
        });
    }
    return [];
};
export default getLowestAndHighestMetrics;
